import ReactOnRails from 'react-on-rails';
import BetSlip from "../bundles/BetSlip/components/BetSlip";

ReactOnRails.register({
    BetSlip,
});
